import { Member } from '@wix/ambassador-members-ng-api/types';
import React from 'react';
import { FormError } from '../../../../types/errors';
import { FormStatus } from '../../../../types/form-state';
import { ServiceData } from '../../../../utils/state/types';
import { useFormComponentContext } from '../../Hooks/useFormComponentContext';
import { PaymentSectionContainerHook } from './dataHooks';
import { getMultiPaymentSelectionContainer } from './MultiPaymentSelectionContainer/MultiPaymentSelectionContainer';
import { classes } from './PaymentSelectionContainer.st.css';

export type PaymentSelectionContainerProps = {
  serviceData: ServiceData;
  memberDetails?: Member;
  numberOfParticipants: number;
  isPricingPlanInstalled: boolean;
  status: FormStatus;
  errors: FormError[];
  isCart: boolean | undefined;
  excludePricingPlanOptions?: boolean;
  participantIndex?: number;
};

export const PaymentSelectionContainer: React.FC<
  PaymentSelectionContainerProps
> = (props) => {
  const { dateRegionalSettingsLocale } = useFormComponentContext();

  const componentToShow = getMultiPaymentSelectionContainer({
    ...props,
    dateRegionalSettingsLocale,
  });
  return (
    componentToShow && (
      <fieldset
        className={classes.root}
        data-hook={
          props.participantIndex !== undefined
            ? `${PaymentSectionContainerHook.Payment_Section}-p${props.participantIndex}`
            : PaymentSectionContainerHook.Payment_Section
        }
      >
        {componentToShow}
      </fieldset>
    )
  );
};
